"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteOrderRelation = exports.postOrderRelation = exports.putOrderOrganization = exports.putOrderAccessibility = exports.deleteOrderPermission = exports.postOrderPermission = exports.putOrderAction = exports.postOrder = exports.putOrder = exports.getOrder = exports.getOrders = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var ordersAuthorizedPath = root_1.ecommerceAuthorized + '/orders/';

var getOrders = function getOrders(authentication, queryParameters) {
  return common_1.get(authentication, ordersAuthorizedPath, queryParameters);
};

exports.getOrders = getOrders;

var getOrder = function getOrder(authentication, id) {
  return common_1.get(authentication, ordersAuthorizedPath + id);
};

exports.getOrder = getOrder;

var putOrder = function putOrder(authentication, order) {
  return common_1.put(authentication, ordersAuthorizedPath + order.id, order);
};

exports.putOrder = putOrder;

var postOrder = function postOrder(authentication, order) {
  return common_1.post(authentication, ordersAuthorizedPath, order);
};

exports.postOrder = postOrder;

var putOrderAction = function putOrderAction(authentication, id, action, data) {
  return common_1.putSub(authentication, ordersAuthorizedPath, id, action, data);
};

exports.putOrderAction = putOrderAction;

var postOrderPermission = function postOrderPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, ordersAuthorizedPath, id, permission);
};

exports.postOrderPermission = postOrderPermission;

var deleteOrderPermission = function deleteOrderPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, ordersAuthorizedPath, id, permissionId);
};

exports.deleteOrderPermission = deleteOrderPermission;

var putOrderAccessibility = function putOrderAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, ordersAuthorizedPath, id, accessibility);
};

exports.putOrderAccessibility = putOrderAccessibility;

var putOrderOrganization = function putOrderOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, ordersAuthorizedPath, id, organizationId);
};

exports.putOrderOrganization = putOrderOrganization;

var postOrderRelation = function postOrderRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, ordersAuthorizedPath, id, relation);
};

exports.postOrderRelation = postOrderRelation;

var deleteOrderRelation = function deleteOrderRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, ordersAuthorizedPath, id, relationId);
};

exports.deleteOrderRelation = deleteOrderRelation;